export interface AnalyticsEvent {
  name: string
  extra?: (attrs: Record<string, any>) => Record<string, any>
}

export const analyticsEvents: Record<string, AnalyticsEvent> = {
  sent_message: {
    name: 'Sent Message',
    extra: (attrs: any) => ({
      'Sender Id': attrs.sender_id,
      'Sender Name': attrs.sender_name,
      'Conversation Id': attrs.conversation_id,
    }),
  },
  switched_message_tabs: {
    name: 'Switched message tabs',
    extra: (attrs: any) => ({
      'Conversation Id': attrs.id,
      From: attrs.from,
      To: attrs.to,
    }),
  },
  created_conversation: {
    name: 'Created conversation',
    extra: (attrs: any) => ({
      'Sender Id': attrs.sender_id,
      'Sender Name': attrs.sender_name,
      'Conversation Id': attrs.conversation_id,
    }),
  },
  signup_submit: {
    name: 'Signup Submit',
    extra: (attrs: any) => ({
      'User Email': attrs.email,
      'User Name': `${attrs.first_name} ${attrs.last_name}`,
    }),
  },

  pro_signup: {
    name: 'Pro Account Created',
    extra: (attrs: any) => ({
      'User ID': attrs.id,
      'User Email': attrs.email,
      'User Name': `${attrs.first_name} ${attrs.last_name}`,
    }),
  },

  client_signup: {
    name: 'Client Account Created',
    extra: (attrs: any) => ({
      'User ID': attrs.id,
      'User Email': attrs.email,
      'User Name': `${attrs.first_name} ${attrs.last_name}`,
    }),
  },

  client_accepted_invitation: {
    name: 'Client Accepted Invitation',
    extra: (attrs: any) => ({
      'User ID': attrs.id,
      'User Email': attrs.email,
      'User Name': `${attrs.first_name} ${attrs.last_name}`,
    }),
  },

  added_alternative_exercise: {
    name: 'Added alternative exercise',
    extra: (attrs: any) => ({
      'Exercise Id': attrs.id,
      'Workout Id': attrs.workoutId,
    }),
  },

  confirm_email: {
    name: 'Email Confirmed',
  },

  pro_login: {
    name: 'Pro Login',
    extra: () => ({
      'Login Time': new Date(),
    }),
  },

  client_login: {
    name: 'Client Login',
    extra: () => ({
      'Login Time': new Date(),
    }),
  },

  pro_logout: {
    name: 'Pro Logout',
    extra: () => ({
      'Logout Time': new Date(),
    }),
  },

  client_logout: {
    name: 'Client Logout',
    extra: () => ({
      'Logout Time': new Date(),
    }),
  },

  client_added: {
    name: 'Client Added',
    extra: (attrs: any) => ({
      'Client Name': attrs.full_name,
    }),
  },

  client_invited: {
    name: 'Client Invited',
    extra: (attrs: any) => ({
      'Client Name': attrs.full_name,
      'Client Email': attrs.email,
    }),
  },

  client_group_created: {
    name: 'Client Group Created',
    extra: (attrs: any) => ({
      'Client Group ID': attrs.id,
      'Client Group Name': attrs.name,
    }),
  },

  client_group_member_added: {
    name: 'Client Group Member Added',
    extra: (attrs: any) => ({
      'Group ID': attrs.groupId,
      'Group Name': attrs.groupName,
      'Client ID': attrs.clientId,
      'Client Name': attrs.clientName,
    }),
  },

  client_group_member_removed: {
    name: 'Client Group Member Removed',
    extra: (attrs: any) => ({
      'Group ID': attrs.groupId,
      'Group Name': attrs.groupName,
      'Client ID': attrs.clientId,
      'Client Name': attrs.clientName,
    }),
  },

  pro_created_exercise: {
    name: 'Pro Created Exercise',
    extra: (attrs: any) => ({
      'Exercise ID': attrs.id,
      'Exercise Name': attrs.name,
    }),
  },

  pro_created_workout: {
    name: 'Pro Created Workout',
    extra: (attrs: any) => ({
      'Workout ID': attrs.id,
      'Workout Name': attrs.name,
    }),
  },

  pro_created_program: {
    name: 'Pro Created Program',
    extra: (attrs: any) => ({
      'Program ID': attrs.id,
      'Program Name': attrs.name,
    }),
  },

  pro_created_product: {
    name: 'Pro Created Product',
    extra: (attrs: any) => ({
      'Product ID': attrs.id,
      'Product Name': attrs.name,
    }),
  },

  pro_created_product_plan: {
    name: 'Pro Created Product Plan',
    extra: (attrs: any) => ({
      'Product Plan ID': attrs.id,
      'Product Plan Name': attrs.name,
    }),
  },

  pro_assigned_exercise: {
    name: 'Pro Assigned Exercise',
    extra: (attrs: any) => ({
      'Exercise ID': attrs.id,
      'Exercise Name': attrs.name,
      'Person ID': attrs.personId,
    }),
  },

  pro_assigned_workout: {
    name: 'Pro Assigned Workout Template',
    extra: (attrs: any) => ({
      'Workout ID': attrs.id,
      'Workout Name': attrs.name,
      'Person ID': attrs.personId,
    }),
  },

  pro_assigned_program: {
    name: 'Pro Assigned Program Template',
    extra: (attrs: any) => ({
      'Program ID': attrs.id,
      'Program Name': attrs.name,
      'Person ID': attrs.personId,
    }),
  },

  pro_unassigned_exercise: {
    name: 'Pro Unassigned Exercise',
    extra: (attrs: any) => ({
      'Exercise ID': attrs.id,
      'Exercise Name': attrs.name,
      'Person ID': attrs.personId,
    }),
  },

  pro_unassigned_workout: {
    name: 'Pro Unassigned Workout Template',
    extra: (attrs: any) => ({
      'Workout ID': attrs.id,
      'Workout Name': attrs.name,
      'Person ID': attrs.personId,
    }),
  },

  pro_unassigned_program: {
    name: 'Pro Unassigned Program Template',
    extra: (attrs: any) => ({
      'Program ID': attrs.id,
      'Program Name': attrs.name,
      'Person ID': attrs.personId,
    }),
  },

  pro_started_workout: {
    name: 'Pro Started Workout',
    extra: (attrs: any) => ({
      'Person ID': attrs.person_id,
      'Person Name': attrs.person_name,
      'Workout ID': attrs.personal_workout_id,
      'Workout Name': attrs.workout_name,
      'Workout Begins At': attrs.begins_at,
      'Workout Ends At': attrs.ends_at,
    }),
  },

  client_started_workout: {
    name: 'Client Started Workout',
    extra: (attrs: any) => ({
      'Person ID': attrs.person_id,
      'Person Name': attrs.person_name,
      'Workout ID': attrs.personal_workout_id,
      'Workout Name': attrs.workout_name,
      'Workout Begins At': attrs.begins_at,
      'Workout Ends At': attrs.ends_at,
    }),
  },

  pro_scheduled_workout: {
    name: 'Pro Scheduled Workout',
    extra: (attrs: any) => ({
      'Person ID': attrs.person_id,
      'Person Name': attrs.person_name,
      'Workout ID': attrs.personal_workout_id,
      'Workout Name': attrs.workout_name,
      'Workout Begins At': attrs.begins_at,
      'Workout Ends At': attrs.ends_at,
    }),
  },

  client_scheduled_workout: {
    name: 'Client Scheduled Workout',
    extra: (attrs: any) => ({
      'Person ID': attrs.person_id,
      'Person Name': attrs.person_name,
      'Workout ID': attrs.personal_workout_id,
      'Workout Name': attrs.workout_name,
      'Workout Begins At': attrs.begins_at,
      'Workout Ends At': attrs.ends_at,
    }),
  },

  pro_completed_workout: {
    name: 'Pro Completed Workout',
    extra: (attrs: any) => ({
      'Person ID': attrs.person_id,
      'Person Name': attrs.person_name,
      'Workout ID': attrs.personal_workout_id,
      'Workout Name': attrs.workout_name,
      'Workout Begins At': attrs.begins_at,
      'Workout Ends At': attrs.ends_at,
    }),
  },

  client_completed_workout: {
    name: 'Client Completed Workout',
    extra: (attrs: any) => ({
      'Person ID': attrs.person_id,
      'Person Name': attrs.person_name,
      'Workout ID': attrs.personal_workout_id,
      'Workout Name': attrs.workout_name,
      'Workout Begins At': attrs.begins_at,
      'Workout Ends At': attrs.ends_at,
    }),
  },

  created_warmup_template: {
    name: 'Created warmup template',
    extra: (attrs: any) => ({
      'Workout ID': attrs.id,
      'Workout Name': attrs.name,
    }),
  },

  created_cooldown_template: {
    name: 'Created cooldown template',
    extra: (attrs: any) => ({
      'Workout ID': attrs.id,
      'Workout Name': attrs.name,
    }),
  },

  set_subscription: {
    name: 'Added Subscription',
    extra: (attrs: any) => ({
      'Plan Id': attrs.subscription.plan?.id,
      'Plan Name': attrs.subscription.plan?.name,
      'Plan Amount': attrs.subscription.plan?.amount,
      'Plan Interval': attrs.subscription.plan?.interval,
      'Subscription Id': attrs.subscription.id,
    }),
  },

  changed_subscription: {
    name: 'Changed Subscription',
    extra: (attrs: any) => ({
      'Plan Id': attrs.subscription.plan?.id,
      'Plan Name': attrs.subscription.plan?.name,
      'Plan Amount': attrs.subscription.plan?.amount,
      'Plan Interval': attrs.subscription.plan?.interval,
      'Subscription Id': attrs.subscription.id,
    }),
  },

  cancel_subscription: {
    name: 'Cancelled Subscription',
    extra: (attrs: any) => ({
      'Plan Id': attrs.subscription.plan?.id,
      'Plan Name': attrs.subscription.plan?.name,
      'Plan Amount': attrs.subscription.plan?.amount,
      'Plan Interval': attrs.subscription.plan?.interval,
      'Subscription Id': attrs.subscription.id,
    }),
  },

  added_warmup: {
    name: 'Added warmup',
    extra: (attrs: any) => ({
      'Workout Id': attrs.id,
      'Workout Name': attrs.name,
      'Warmup Id': attrs.warmupId,
    }),
  },

  added_cooldown: {
    name: 'Added cooldown',
    extra: (attrs: any) => ({
      'Workout Id': attrs.id,
      'Workout Name': attrs.name,
      'Cooldown Id': attrs.cooldownId,
    }),
  },
  uploaded_video_library: {
    name: 'Uploaded Video (library)',
    extra: (attrs: any) => ({
      'Video Id': attrs.id,
      'Vodeo URL': attrs.url,
      'Vodeo Name': attrs.name,
    }),
  },
  uploaded_video_exercise: {
    name: 'Uploaded Video (exercise)',
    extra: (attrs: any) => ({
      'Video Id': attrs.id,
      'Vodeo URL': attrs.url,
      'Vodeo Name': attrs.name,
    }),
  },
  uploaded_video_workout: {
    name: 'Uploaded Video (workout)',
    extra: (attrs: any) => ({
      'Video Id': attrs.id,
      'Vodeo URL': attrs.url,
      'Vodeo Name': attrs.name,
    }),
  },
  uploaded_video_program_workout: {
    name: 'Uploaded Video (program workout)',
    extra: (attrs: any) => ({
      'Video Id': attrs.id,
      'Vodeo URL': attrs.url,
      'Vodeo Name': attrs.name,
    }),
  },
  uploaded_video_program: {
    name: 'Uploaded Video (program overview)',
    extra: (attrs: any) => ({
      'Video Id': attrs.id,
      'Vodeo URL': attrs.url,
      'Vodeo Name': attrs.name,
    }),
  },

  added_video_exercise: {
    name: 'Added Video (exercise)',
    extra: (attrs: any) => ({
      'Video Id': attrs.id,
      'Vodeo URL': attrs.url,
      'Vodeo Name': attrs.name,
    }),
  },

  added_video_workout: {
    name: 'Added Video (workout)',
    extra: (attrs: any) => ({
      'Video Id': attrs.id,
      'Vodeo URL': attrs.url,
      'Vodeo Name': attrs.name,
    }),
  },
  added_video_program_workout: {
    name: 'Added Video (program workout)',
    extra: (attrs: any) => ({
      'Video Id': attrs.id,
      'Vodeo URL': attrs.url,
      'Vodeo Name': attrs.name,
    }),
  },
  added_video_program: {
    name: 'Added Video (program overview)',
    extra: (attrs: any) => ({
      'Video Id': attrs.id,
      'Vodeo URL': attrs.url,
      'Vodeo Name': attrs.name,
    }),
  },
  assigned_document: {
    name: 'Assigned document',
    extra: (attrs: any) => ({
      'Document Name': attrs.name,
    }),
  },
  uploaded_document: {
    name: 'Uploaded document',
    extra: (attrs: any) => ({
      'Document Name': attrs.name,
    }),
  },
  clicked_print_button: {
    name: 'Clicked Print button',
  },
  played_video: {
    name: 'Played video',
  },
  paused_video: {
    name: 'Paused video',
  },
  ended_video: {
    name: 'Ended video',
  },
  archived_client: {
    name: 'Archived client',
  },
  restored_client: {
    name: 'Restored client',
  },
  created_folder: {
    name: 'Created folder',
    extra: (attrs: any) => ({
      'Folder Name': attrs.name,
    }),
  },
  changed_exercise_position: {
    name: 'Changed exercise position',
  },
  changed_property_position: {
    name: 'Changed exercise property position',
  },
  viewed_folder: {
    name: 'Viewed Folder',
    extra: (attrs: any) => ({
      'Folder ID': attrs.id,
      'Folder Name': attrs.name,
    })
  },
  viewed_exercise: {
    name: 'Viewed Exercise',
    extra: (attrs: any) => ({
      'Exercise ID': attrs.id,
      'Exercise Name': attrs.name,
    })
  },
  viewed_personal_exercise: {
    name: 'Viewed Personal Exercise',
    extra: (attrs: any) => ({
      'Exercise ID': attrs.id,
      'Exercise Name': attrs.name,
    })
  },
  viewed_workout_exercise: {
    name: 'Viewed Workout Exercise',
    extra: (attrs: any) => ({
      'Exercise ID': attrs.id,
      'Exercise Name': attrs.name,
      'Workout Name': attrs.workout_name,
    })
  },
  viewed_workout_template: {
    name: 'Viewed Workout Template',
    extra: (attrs: any) => ({
      'Workout ID': attrs.id,
      'Workout Name': attrs.name,
    })
  },
  viewed_personal_workout: {
    name: 'Viewed Personal Workout',
    extra: (attrs: any) => ({
      'Workout ID': attrs.id,
      'Workout Name': attrs.name,
    })
  },
  viewed_program_template: {
    name: 'Viewed Program Template',
    extra: (attrs: any) => ({
      'Program ID': attrs.id,
      'Program Name': attrs.name,
    })
  },
  viewed_personal_program: {
    name: 'Viewed Personal Program',
    extra: (attrs: any) => ({
      'Program ID': attrs.id,
      'Program Name': attrs.name,
    })
  },
  viewed_program_workout_template: {
    name: 'Viewed Program Workout',
    extra: (attrs: any) => ({
      'Workout ID': attrs.id,
      'Workout Name': attrs.name,
      'Program Name': attrs.program_name,
    }),
  },
  viewed_program_personal_workout: {
    name: 'Viewed Personal Program Workout',
    extra: (attrs: any) => ({
      'Workout ID': attrs.id,
      'Workout Name': attrs.name,
      'Program Name': attrs.program_name,
    }),
  },
  viewed_document: {
    name: 'Viewed Document',
    extra: (attrs: any) => ({
      'Document ID': attrs.id,
      'Document Name': attrs.name,
    })
  },
  viewed_user_profile: {
    name: 'Viewed User Profile',
    extra: (attrs: any) => ({
      'User ID': attrs.id,
    })
  },
  viewed_my_profile: {
    name: 'Viewed My Training Log',
    extra: (attrs: any) => ({
      'User ID': attrs.id,
    })
  },
  viewed_results: {
    name: 'Viewed Results',
    extra: (attrs: any) => ({
      'Event ID': attrs.id,
      'Program Name': attrs.program_name,
      'Workout Name': attrs.workout_name,
    })
  },
  pro_created_personal_workout: {
    name: 'Pro created personal workout',
    extra: (attrs: any) => ({
      'Workout ID': attrs.id,
      'Workout Name': attrs.name,
    }),
  },
  pro_created_personal_program: {
    name: 'Pro created personal program',
    extra: (attrs: any) => ({
      'Program ID': attrs.id,
      'Program Name': attrs.name,
    }),
  },
  opened_upgrade_plan_popup: {
    name: 'Opened upgrade popup',
  },
  clicked_learn_more: {
    name: 'Clicked Learn More',
  },
  clicked_upgrade_plan: {
    name: 'Clicked Upgrade Now button',
  },
  signup_viewed: {
    name: 'Signup - Visited page',
  },
  signup_clicked_create_account: {
    name: 'Signup - Clicked “Create My Account”',
  },
  signup_clicked_contintue_account: {
    name: 'Signup - Clicked “Continue” (started trial)',
  },
  signup_clicked_skipped_account: {
    name: 'Signup - Skipped subscription trial',
  },
  pro_clicked_learn_more: {
    name: 'Pro clicked Learn More video (exercises)',
  },
}
